export const COMPLEX_DOC_SIDEBAR = {
  LETS_DESIGN_TAB_TOOLTIP: {
    key: 'LETS_DESIGN_TAB_TOOLTIP',
    value: "Let's Design"
  },
  CREATIVE_DESIGN_ELEMENTS_TAB_TOOLTIP: {
    key: 'CREATIVE_DESIGN_ELEMENTS_TAB_TOOLTIP',
    value: "Creative elements"
  },
  SETTINGS_TAB_TOOLTIP: { key: 'SETTINGS_TAB_TOOLTIP', value: 'Document Settings' },
}

export const COMPLEX_DESIGN_TOOLBAR = {
  UNDO_TOOLTIP: {
    key: 'UNDO_TOOLTIP',
    value: "Undo changes"
  },
  REDO_TOOLTIP: {
    key: 'REDO_TOOLTIP',
    value: "Redo changes"
  },
  AUTO_SAVE_CHANGES_TOOLTIP: {
    key: 'AUTO_SAVE_CHANGES_TOOLTIP',
    value: 'Auto saving changes'
  },
  NO_INTERNET_TOOLTIP: {
    key: 'NO_INTERNET_TOOLTIP',
    value: 'You are currently offline, please check your network connection. Stay on the page, once you are back online we will sync your design.'
  },
  BLOCK_DESIGN_MODAL: {
    key: 'BLOCK_DESIGN_MODAL',
    value: 'We are unable to save your changes due to technical difficulties. Please connect with the support team or retry after some time. Error Code : '
  },
  UPDATE_TEMPLATE_NAME_ERROR_MESSAGE: {
    key: 'UPDATE_TEMPLATE_NAME_ERROR_MESSAGE',
    value: 'An error occurred while attempting to update the template name',
  },
  TEMPLATE_NAME_EMPTY_WARNING_MESSAGE: {
    key: 'TEMPLATE_NAME_EMPTY_WARNING_MESSAGE',
    value: 'The template name is required and cannot be left empty.',
  },
  READ_MODE_LABEL: {
    key: 'READ_MODE_LABEL',
    value: 'Read Mode',
  },
  RULER_LABEL: {
    key: 'RULER_LABEL',
    value: 'Ruler',
  },
  ERROR_SWITCHING_READ_MODE: {
    key: 'ERROR_SWITCHING_READ_MODE',
    value: 'There was an error when attempting to switch to read mode.',
  },
  ERROR_SWITCHING_EDITABLE_MODE: {
    key: 'ERROR_SWITCHING_EDITABLE_MODE',
    value: 'There was an error when attempting to switch to editable mode.',
  },
  PREVIEW_AND_DOWNLOAD_BUTTON:{
    key: 'PREVIEW_AND_DOWNLOAD_BUTTON',
    value: 'Preview & Download',
  },
  EXIT_PREVIEW_AND_DOWNLOAD_BUTTON:{
    key: 'EXIT_PREVIEW_AND_DOWNLOAD_BUTTON',
    value: 'Exit Preview & Download',
  },
  ERROR_IN_DOCUMENT:{ 
    key: 'ERROR_IN_DOCUMENT', 
    value: 'Please fix the errors in the template design before sending it for testing.',
  },
  DOWNLOAD_PREVIEW_TOOLTIP_TEXT: {
    key: 'DOWNLOAD_PREVIEW_TOOLTIP_TEXT',
    value: 'Click to preview & download'
  },
  SUPPORT_TOOLTIP_TEXT: {
    key: 'SUPPORT_TOOLTIP_TEXT',
    value: 'Help'
  },
  PREVIEW_PAGE_NUMNER: {
    key: 'PREVIEW_PAGE_NUMNER',
    value: 'Page Number'
  },
  PREVIEW_PAGE_NO: {
    key: 'PREVIEW_PAGE_NO',
    value: 'Page No'
  },
  MAX_CHAR_LIMIT_EXCEEDED_ERROR: { key: 'MAX_CHAR_LIMIT_EXCEEDED_ERROR', value: 'Maximum of {{charLimitLength}} characters allowed' },
  PREVIEW_BUTTON: { key: 'PREVIEW_BUTTON', value: 'Preview' },
  EXIT_PREVIEW_BUTTON: { key: 'EXIT_PREVIEW_BUTTON', value: 'Exit Preview' },
  COMPLETE_TRANSACTION_LABEL: { key: 'COMPLETE_TRANSACTION_LABEL', value: 'Complete Transaction' },
  COMMUNICATION_NAME_EXIST_ERROR: { key: 'COMMUNICATION_NAME_EXIST_ERROR', value: 'The communication name already exists!' },
  VERSION_DRAFT: { key: 'VERSION_DRAFT', value: 'Draft' },
  VERSION_TESTING: { key: 'VERSION_TESTING', value: 'Testing' },
  VERSION_PUBLISHED: { key: 'VERSION_PUBLISHED', value: 'Published' },
  SEND_LETTER_LABEL: { key: 'SEND_LETTER_LABEL', value: 'Send Letter' },
  DOCUMENT_NAME_UNSUPPORTED_CHARS: {
    key: 'DOCUMENT_NAME_UNSUPPORTED_CHARS',
    value: 'The name contains unsupported characters: "{{char}}". Please use only letters, numbers, or these special characters: - _ ( ).'
  },
  UPDATE_TEMPLATE_NAME_UNSUPPORTED_CHARS: {
    key: 'UPDATE_TEMPLATE_NAME_UNSUPPORTED_CHARS',
    value: 'The name contains unsupported characters: "{{char}}". Please use only letters, numbers, or these special characters: - _ ( ).'
  },
}

export const COMPLEX_PAGE_OPTIONS = {
  PAGE_SETTING_HEADER: {
    key: 'PAGE_SETTING_HEADER',
    value: 'Page settings'
  },
  PAGE_HEADER_TEXT: {
    key: 'PAGE_HEADER_TEXT',
    value: 'Page {{index}} of {{totalPages}}'
  },
  ADD_NEW_PAGE_BUTTON: {
    key: 'ADD_NEW_PAGE_BUTTON',
    value: 'Add new page'
  },
  DELETE_PAGE_BUTTON: {
    key: 'DELETE_PAGE_BUTTON',
    value: 'Delete this page'
  },
  DELETE_PAGE_OVERLAY_MESSAGE: {
    key: 'DELETE_PAGE_OVERLAY_MESSAGE',
    value: 'Deleting this page will delete any business logics/rules associated with the blocks of this page. Are you sure to delete this page?'
  },
  PAGE_SETTING_BUTTON: {
    key: 'PAGE_SETTING_BUTTON',
    value: 'Page settings'
  },
  BLOCK_SETTING_BUTTON: {
    key: 'BLOCK_SETTING_BUTTON',
    value: 'Block settings'
  },
  HEADER_OR_FOOTER_ALREADY_EXISTS: {
    key: 'HEADER_OR_FOOTER_ALREADY_EXISTS',
    value: '{{type, capitalize}} already exists'
  },
  HEIGHT_DOES_NOT_FIT_CONTENT: {
    key: 'CONTENT_DOES_NOT_FIT_HEIGHT',
    value: 'Some blocks are of height greater than the design area. Kindly retry after altering the block heights!!'
  },
  WIDTH_DOES_NOT_FIT_CONTENT: {
    key: 'WIDTH_DOES_NOT_FIT_CONTENT',
    value: 'Width of design area is too small!!'
  },
  EMPTY_PAGE_PLACEHOLDER: {
    key: 'EMPTY_PAGE_PLACEHOLDER',
    value: 'Drag content from left'
  },
  EMPTY_CREATIVE_BLOCK_PLACEHOLDER: {
    key: 'EMPTY_CREATIVE_BLOCK_PLACEHOLDER',
    value: 'Double click to start designing'
  },
  HTML_DEFAULT_CONTENT_PROMPT: {
    key: 'HTML_DEFAULT_CONTENT_PROMPT',
    value: 'Double click to provide default content'
  },
  EMPTY_COMPLEX_HEADER_OR_FOOTER_PLACEHOLDER: {
    key: 'EMPTY_HEADER_OR_FOOTER_PLACEHOLDER',
    value: 'Double click to design header / footer'
  },
  SWAP_WITH_PREVIOUS_PAGE: {
    key: 'SWAP_WITH_PREVIOUS_PAGE',
    value: 'Swap with previous page'
  },
  SWAP_WITH_NEXT_PAGE: {
    key: 'SWAP_WITH_NEXT_PAGE',
    value: 'Swap with next page'
  },
  EXPAND_PAGE_BUTTON_TOOLTIP: {
    key: 'EXPAND_PAGE_BUTTON_TOOLTIP',
    value: 'View all page contents'
  },
  COLLAPSE_PAGE_BUTTON_TOOLTIP: {
    key: 'COLLAPSE_PAGE_BUTTON_TOOLTIP',
    value: 'Collapse page contents'
  },
  DROP_CONTENT_HERE_LABEL: {
    key: 'DROP_CONTENT_HERE_LABEL',
    value: 'Drop content here'
  },
  CHANGE_SIZE_LABEL: {
    key: 'CHANGE_SIZE_LABEL',
    value: 'Size In'
  },
  PAGE_SIZE_LABEL: {
    key: 'PAGE_SIZE_LABEL',
    value: 'Page size'
  },
  PAGE_ORIENTATION_LABEL: {
    key: 'PAGE_ORIENTATION_LABEL',
    value: 'Page orientation'
  },
  PAGE_ORIENTATION_PORTRAIT_OPTION: {
    key: 'PAGE_ORIENTATION_PORTRAIT_OPTION',
    value: 'Portrait'
  },
  PAGE_ORIENTATION_LANDSCAPE_OPTION: {
    key: 'PAGE_ORIENTATION_LANDSCAPE_OPTION',
    value: 'Landscape'
  },
  PAGE_HEIGHT_LABEL: {
    key: 'PAGE_HEIGHT_LABEL',
    value: 'Height'
  },
  PAGE_WIDTH_LABEL: {
    key: 'PAGE_WIDTH_LABEL',
    value: 'Width'
  },
  PAGE_BACKGROUND_LABEL: {
    key: 'PAGE_BACKGROUND_LABEL',
    value: 'Background'
  },
  PAGE_TOP_MARGIN_LABEL: {
    key: 'PAGE_TOP_MARGIN_LABEL',
    value: 'Top Margin'
  },
  PAGE_BOTTOM_MARGIN_LABEL: {
    key: 'PAGE_BOTTOM_MARGIN_LABEL',
    value: 'Bottom Margin'
  },
  PAGE_LEFT_MARGIN_LABEL: {
    key: 'PAGE_LEFT_MARGIN_LABEL',
    value: 'Left Margin'
  },
  PAGE_RIGHT_MARGIN_LABEL: {
    key: 'PAGE_RIGHT_MARGIN_LABEL',
    value: 'Right Margin'
  },
  CREATE_NEW_PAGE_TOOLTIP: {
    key: 'CREATE_NEW_PAGE_TOOLTIP',
    value: 'Create new page'
  },
  EDIT_LAYOUT_TOOLTIP: {
    key: 'EDIT_LAYOUT_TOOLTIP',
    value: 'Click here to edit these pages'
  },
  MAKE_REUSABLE_PAGE: {
    key: 'MAKE_REUSABLE_PAGE',
    value: 'Make this page  reusable'
  },
  BLOCK_UNSELECT_WARNING: {
    key: 'BLOCK_UNSELECT_WARNING',
    value: "You can't unselect a block in the middle of the block sequence."
  },
  HEADER_FOOTER_SELECTED_WARNING:{
    key: 'HEADER_FOOTER_SELECTED_WARNING',
    value: "{{blockType}} is selected, so you can't select any other block."
  },
  CONTENT_SELECTED_WARNING:{
    key: 'CONTENT_SELECTED_WARNING',
    value: "Content is selected, so you can't select header or footer block."
  },
  HEADER_FOOTER_REFERENCED_WARNING:{
    key: 'HEADER_FOOTER_REFERENCED_WARNING',
    value: '{{blockType}} is already referenced.'
  },
  BLOCK_SELECTION_SEQUENCE_WARNING: {
    key: 'BLOCK_SELECTION_SEQUENCE_WARNING',
    value: "Please select blocks in order"
  },
  UPLOADING_INFO_MESSAGE: {
    key: 'UPLOADING_INFO_MESSAGE',
    value: 'Please wait, we are uploading your image(s).',
  },
  FILE_NOT_SUPPORTED_ERROR_MESSAGE: {
    key: 'FILE_NOT_SUPPORTED_ERROR_MESSAGE',
    value: 'Unsupported files!!',
  },
  CREATIVE_BLOCK_HEIGHT_OVERFLOW_ERROR_MESSAGE: {
    key: 'CREATIVE_BLOCK_HEIGHT_OVERFLOW_ERROR_MESSAGE',
    value: 'Height of this creative block exceeds the height of the page.'
  },
  CREATIVE_BLOCK_HEIGHT_OVERFLOW_INFO:{
    key: 'CREATIVE_BLOCK_HEIGHT_OVERFLOW_INFO',
    value: 'Creating a creative block taller than the page will affect document generation because it cannot overflow onto additional pages. To fix this issue, split the creative block into multiple sections if its height exceeds the page height. Until you resolve this, the document cannot be previewed or downloaded.'
  },
  CREATIVE_BLOCK_HEADER_FOOTER_MAX_HEIGHT_ERROR:{
    key: 'CREATIVE_BLOCK_HEADER_FOOTER_MAX_HEIGHT_ERROR',
    value: '{{value}} block cannot extend beyond the height of the page.'
  },
  HEADER_FOOTER_ALREADY_MAX_HEIGHT:{
    key: 'HEADER_FOOTER_ALREADY_MAX_HEIGHT',
    value: 'The {{otherElement}} on the page is as tall as the page. To add a {{dropElement}}, you need to revise the header design to create space.'
  },
  AI_TEXT_GENERATE_FREE_PLAN_LIMIT_EXCEEDED_MESSAGE: {
    key: 'AI_TEXT_GENERATE_FREE_PLAN_LIMIT_EXCEEDED_MESSAGE',
    value: 'Your current plan lacks the capability to generate text due to its limited features. To access this feature, you can upgrade your plan.'
  },
  AI_TEXT_GENERATE_PREMIUM_PLAN_LIMIT_EXCEEDED_MESSAGE: {
    key: 'AI_TEXT_GENERATE_PREMIUM_PLAN_LIMIT_EXCEEDED_MESSAGE',
    value: "You've reached the text generation limit under your current plan. You can opt to wait until the next month when your limit resets, or you have the option to explore upgrading your plan."
  },
  TEXT_GENERATION_FAILED: {
    key: 'TEXT_GENERATION_FAILED',
    value: 'The text generation process failed.'
  },
  PREMIUM_PLAN_TEXT_GENERATION_LIMIT_REACHED: {
    key: 'PREMIUM_PLAN_TEXT_GENERATION_LIMIT_REACHED',
    value: 'You have reached the limit for text generation under your current plan. You can either wait until your quota renews next month or upgrade to an enterprise plan. For assistance with upgrading, please contact our support team at <a href="mailto:{{emailId}}">{{emailId}}<a>.'
  },
  DOUBLE_CLICK_TO_EDIT_TOOLTIP_TEXT: {
    key: 'DOUBLE_CLICK_TO_EDIT_TOOLTIP_TEXT',
    value: 'Double click on any section to edit'
  },
  TOC_ALREADY_EXISTS: {
    key: 'TOC_ALREADY_EXISTS',
    value: 'Table of contents already exists'
  },
  TOC_RELOAD: {
    key: 'TOC_RELOAD',
    value: 'Refresh table of contents'
  },
  TOC_RELOAD_ERROR: {
    key: 'TOC_RELOAD_ERROR',
    value: 'Failed to refresh table of contents'
  },
  TOC_TITLE: {
    key: 'TOC_TITLE',
    value: 'Title'
  },
  TOC_SECTION: {
      key: 'SECTION',
      value: 'Section'
  },
  TOC_SUB_SECTION: {
      key: 'SUB_SECTION',
      value: 'Sub-section'
  },
  TOC_PLACEHOLDER: {
    key: 'TOC_PLACEHOLDER',
    value: 'Add titles, sections, and subsections to the document, then refresh here to generate your Table of Contents page.'
  },
  DUPLICATE_THIS_PAGE_TOOLTIP: {
    key: 'DUPLICATE_THIS_PAGE_TOOLTIP',
    value: 'Duplicate this page',
  },
  FORM_ELEMENTS_NOT_SUPPORT: {
    key: 'FORM_ELEMENTS_NOT_SUPPORT',
    value: 'Form elements are not supported within the repeat block.',
  },
  PAGE_NUMBER_LABEL: {
    key: 'PAGE_NUMBER_LABEL',
    value: 'Page Numbers'
  },
  NO_LABEL: {
    key: 'NO_LABEL',
    value: 'No'
  },
  YES_LABEL: {
    key: 'YES_LABEL',
    value: 'Yes'
  },
  ADD_BUSINESS_LOGIC_LABEL: {
    key: 'ADD_BUSINESS_LOGIC_LABEL',
    value: 'Add business logic',
  },
  VIEW_BUSINESS_LOGIC_LABEL: {
    key: 'VIEW_BUSINESS_LOGIC_LABEL',
    value: 'View business logic',
  },
}

export const COMPLEX_DESIGN_ELEMENTS = {
  TEXT_ELEMENT_LABEL: {
    key: 'TEXT_ELEMENT_LABEL',
    value: "Text"
  },
  CREATIVE_BLOCK_ELEMENT_LABEL: {
    key: 'CREATIVE_BLOCK_ELEMENT_LABEL',
    value: "Creative Block"
  },
  HEADER_LABEL: {
    key: 'HEADER_LABEL',
    value: 'Header'
  },
  FOOTER_LABEL: {
    key: 'FOOTER_LABEL',
    value: 'Footer'
  },
  REPETITIVE_BLOCK_LABEL: {
    key: 'REPETITIVE_BLOCK_LABEL',
    value: 'Repeated block'
  },
  DYNAMIC_TABLE_BLOCK_LABEL: {
    key: 'DYNAMIC_TABLE_BLOCK_LABEL',
    value: 'Dynamic Table'
  },
  DYNAMIC_TABLE_DEFAULT_HEADER: {
    key: 'DYNAMIC_TABLE_DEFAULT_HEADER',
    value: 'Header {{index}}'
  },
  TABLE_OF_CONTENTS: {
    key: 'TABLE_OF_CONTENTS',
    value: 'Table of contents'
  },
  TOOLTIP_TEXT: {
    key: 'TOOLTIP_TEXT',
    value: 'Drag and drop from here onto the design'
  },
  STATIC_TABLE_BLOCK_LABEL: {
    key: 'STATIC_TABLE_BLOCK_LABEL',
    value: 'Static Table'
  },
}

export const BLOCK_SETTINGS_OPTIONS = {
  BLOCK_BACKGROUND_COLOR_TOOLTIP: {
    key: 'BLOCK_BACKGROUND_COLOR_TOOLTIP',
    value: 'Background color',
  },
  DELETE_BLOCK_TOOLTIP: {
    key: 'DELETE_BLOCK_TOOLTIP',
    value: 'Delete this section'
  },
  SETTINGS_TOOLTIP: {
    key: 'SETTINGS_TOOLTIP',
    value: 'Settings'
  },
  EDIT_SECTION_TOOLTIP: {
    key: 'EDIT_SECTION_TOOLTIP',
    value: 'Edit this section'
  },
  MAKE_REUSABLE_SECTION_TOOLTIP: {
    key: 'MAKE_REUSABLE_SECTION_TOOLTIP',
    value: 'Make selected sections to reusable'
  },
  BLOCK_SETTINGS_TAG_LABEL: {
    key: 'BLOCK_SETTINGS_TAG_LABEL',
    value: 'Change Block Settings'
  },
  DELETE_BLOCK_CONFIRMATION_POPUP_LABEL: {
    key: 'DELETE_BLOCK_CONFIRMATION_POPUP_LABEL',
    value: 'Deleting this block will delete any business logic/rules associated with it. are you sure to delete this block?'
  },
  DELETE_BLOCK_CONFIRMATION_YES_BUTTON: {
    key: 'DELETE_BLOCK_CONFIRMATION_YES_BUTTON',
    value: 'Yes'
  },
  DELETE_BLOCK_CONFIRMATION_NO_BUTTON: {
    key: 'DELETE_BLOCK_CONFIRMATION_NO_BUTTON',
    value: 'No'
  },
  VARIABLE_NAME_SPECIAL_CHARACTER_ERROR_MESSAGE: {
    key: 'VARIABLE_NAME_SPECIAL_CHARACTER_ERROR_MESSAGE',
    value: 'Variable name cannot contain any special characters or spaces other than hyphen(-)'
  },
  BLOCK_BACKGROUND_LABEL: {
    key: 'BLOCK_BACKGROUND_LABEL',
    value: 'Set Background Color'
  },
  BLOCK_ALIGNMENT_LABEL: {
    key: 'BLOCK_ALIGNMENT_LABEL',
    value: 'Alignment'
  },
  VARIABLE_NAME_LABEL: {
    key: 'VARIABLE_NAME_LABEL',
    value: 'Variable Name'
  },
  SECTION_NAME_LABEL: {
    key: 'SECTION_NAME_LABEL',
    value: 'Section Name'
  },
  SECTION_NAME_PLACEHOLDER: {
    key: 'SECTION_NAME_PLACEHOLDER',
    value: 'Section Name'
  },
  REPEAT_BLOCK_LABEL: {
    key: 'REPEAT_BLOCK_LABEL',
    value: 'Repeat section'
  },
  REPEAT_ONLY_WITH_VARIABLES_TOOLTIP: {
    key: 'REPEAT_ONLY_WITH_VARIABLES_TOOLTIP',
    value: 'Can be repeated only when variables are used within the block'
  },
  LEFT_SPACING_LABEL: {
    key: 'LEFT_SPACING_LABEL',
    value: 'Left Spacing'
  },
  RIGHT_SPACING_LABEL: {
    key: 'RIGHT_SPACING_LABEL',
    value: 'Right Spacing'
  },
  BOTTOM_SPACING_LABEL: {
    key: 'BOTTOM_SPACING_LABEL',
    value: 'Bottom Spacing'
  },
  TOP_SPACING_LABEL: {
    key: 'TOP_SPACING_LABEL',
    value: 'Top Spacing'
  },
  ALL_SIDES_SPACING_LABEL: {
    key: 'ALL_SIDES_SPACING_LABEL',
    value: 'All Sides'
  },
  ADD_SPACE_TO_SECTION_LABEL: {
    key: 'ADD_SPACE_TO_SECTION_LABEL',
    value: 'Add Spaces to this section'
  },
  BLOCK_NAME_UPDATE_FAILED_MESSAGE: {
    key: 'BLOCK_NAME_UPDATE_FAILED_MESSAGE',
    value: 'The block name update failed due to an error.',
  },
  BLOCK_NAME_EMPTY_WARNING_MESSAGE: {
    key: 'BLOCK_NAME_EMPTY_WARNING_MESSAGE',
    value: 'The block name must not be empty.',
  },
  BLOCK_HEADER_ACCESSIBILITY_LABEL: {
    key: 'BLOCK_HEADER_ACCESSIBILITY_LABEL',
    value: 'Enable Accessibility'
  },
  BLOCK_ACCESSIBILITY_SUMMARY_LABEL: {
    key: 'BLOCK_ACCESSIBILITY_SUMMARY_LABEL',
    value: 'Accessibility Summary'
  },
  BLOCK_ACCESSIBILITY_SUMMARY_PLACEHOLDER: {
    key: 'BLOCK_ACCESSIBILITY_SUMMARY_PLACEHOLDER',
    value: 'Add Accessibility Summary'
  },
  BLOCK_ACCESSIBILITY_SUMMARY_TOOLTIP: {
    key: 'BLOCK_ACCESSIBILITY_SUMMARY_TOOLTIP',
    value: ' Provide a summary to enable screen reader users a quick understanding of the section before navigating through the contents in detail '
  },
  SCREEN_READER_SETTINGS_TAB: {
    key: 'SCREEN_READER_SETTINGS_TAB',
    value: 'Screen reader settings'
  },
  SCREEN_READER_SETTINGS_TOOLTIP: {
    key: 'SCREEN_READER_SETTINGS_TOOLTIP',
    value: 'Add helpful descriptions for screen readers to make your document easier to understand for all users.'
  },
  ENABLE_SECTION_SUMMARY_LABEL: {
    key: 'ENABLE_SECTION_SUMMARY_LABEL',
    value: 'Enable Section Summary'
  },
  ENABLE_SECTION_SUMMARY_TOOLTIP: {
    key: 'ENABLE_SECTION_SUMMARY_TOOLTIP',
    value: 'Toggle to allow screen readers to read out added summary.'
  },
  HEADER_FOOTER_SUMMARY_NOTE: {
    key: 'HEADER_FOOTER_SUMMARY_NOTE',
    value: 'Note: Screen readers skip headers and footers by default, but will read the first header or last footer if a summary is provided. Add a summary to convey essential information.'
  },
  SECTION_SUMMARY_LABEL: {
    key: 'SECTION_SUMMARY_LABEL',
    value: 'Section Summary'
  },
  SECTION_SUMMARY_TOOLTIP: {
    key: 'SECTION_SUMMARY_TOOLTIP',
    value: 'Provide a short summary that helps screen readers explain this section.'
  },
  ACCESSIBILITY_TAB: {
    key: 'ACCESSIBILITY_LABEL',
    value: 'Accessibility'
  },
  EDITABLE_LABEL: {
    key: 'EDITABLE_LABEL',
    value: 'Editable'
  },
  EDITABLE_TOOLTIP: {
    key: 'EDITABLE_TOOLTIP',
    value: 'Enable this option to allow this section to be edited during interactive document customization.'
  },
  LINE_SPACING_LABEL: {
    key: 'LINE_SPACING_LABEL',
    value: 'Line Spacing'
  },
  PARAGRAPH_SPACING_LABEL: {
    key: 'PARAGRAPH_SPACING_LABEL',
    value: 'Paragraph Spacing'
  },
  BLOCK_NAME_UNSUPPORTED_CHARS: {
    key: 'BLOCK_NAME_UNSUPPORTED_CHARS',
    value: 'The name contains unsupported characters: "{{char}}". Please use only letters, numbers, or these special characters: - _ ( ).'
  },
}

export const BLOCK_SETTINGS_TABS = {
  BLOCK_SETTINGS_TAB_SETTINGS: {
    key: 'BLOCK_SETTINGS_TAB_SETTINGS',
    value: 'Settings'
  },
  BLOCK_SETTINGS_TAB_ACCESSIBILITY: {
    key: 'BLOCK_SETTINGS_TAB_ACCESSIBILITY',
    value: 'Accessibility'
  }
}

export const BUSINESS_LOGIC_TAB = {
  BUSINESS_LOGIC_LABEL: {
    key: 'BUSINESS_LOGIC_LABEL',
    value: 'Business Logic',
  },
  CONDITIONS_LABEL: {
    key: 'CONDITION_LABEL',
    value: 'CONDITIONS',
  },
  RULE_LABEL: {
    key: 'RULE_LABEL',
    value: 'RULE',
  },
  RESULT_LABEL: {
    key: 'RESULT_LABEL',
    value: 'RESULT',
  },
  DISPLAY_LABEL: {
    key: 'DISPLAY_LABEL',
    value: 'Display',
  },
  ADD_NEW_BUSINESS_LOGIC: {
    key: 'ADD_NEW_BUSINESS_LOGIC',
    value: 'Add New Business Logic',
  },
  ADD_MORE_RULE: {
    key: 'ADD_MORE_RULE',
    value: 'Add More Rule',
  },
  BUSINESS_LOGIC_NAME_TOOLTIP_TEXT: {
    key: 'BUSINESS_LOGIC_NAME_TOOLTIP_TEXT',
    value: 'Click to enter name',
  },
  CONDITION_SELECT_TOOLTIP_TEXT: {
    key: 'CONDITION_SELECT_TOOLTIP_TEXT',
    value: 'Select a variable',
  },
  NEW_CONDITION: {
    key: 'NEW_CONDITION',
    value: 'New Condition',
  },
  REMOVE_CONDITION_TOOLTIP: {
    key: 'REMOVE_CONDITION_TOOLTIP',
    value: 'Remove Condition',
  },
  REMOVE_RULE_TOOLTIP: {
    key: 'REMOVE_RULE_TOOLTIP',
    value: 'Remove Rule',
  },
  EDIT_BL_TOOLTIP: {
    key: 'EDIT_BL_TOOLTIP',
    value: 'Edit business logic',
  },
  DELETE_BL_TOOLTIP: {
    key: 'DELETE_BL_TOOLTIP',
    value: 'Delete business logic',
  },
  HOW_TO_ADD_RULES: {
    key: 'HOW_TO_ADD_RULES',
    value: 'How to add rules?',
  },
  BL_NAME_PLACEHOLDER: {
    key: 'BL_NAME_PLACEHOLDER',
    value: 'Enter a name for your business Logic',
  },
  BL_VARIABLE_PLACEHOLDER: {
    key: 'BL_VARIABLE_PLACEHOLDER',
    value: 'Select a variable',
  },
  BL_VARIABLE_TEXT: {
    key: 'BL_VARIABLE_TEXT',
    value: 'Select a variable to add conditions',
  },
  BL_SECTION_PLACEHOLDER: {
    key: 'BL_SECTION_PLACEHOLDER',
    value: 'Select a section',
  },
  BL_SECTION_TEXT: {
    key: 'BL_SECTION_TEXT',
    value: 'Search and select the document Section to display',
  },
  SAVE_THIS_LOGIC: {
    key: 'SAVE_THIS_LOGIC',
    value: 'Save this Logic',
  },
  APPLY_LOGIC: {
    key: 'APPLY_LOGIC',
    value: 'Apply this Logic',
  },
  SUCCESSFULLY_SAVED: {
    key: 'SUCCESSFULLY_SAVED',
    value: 'Successfully saved',
  },
  LEARN_MORE_RETURN: {
    key: 'LEARN_MORE_RETURN',
    value: 'Learn about return values',
  },
  UNIQUE_NAME_ERROR: {
    key: 'UNIQUE_NAME_ERROR',
    value: 'Enter a Unique Name for the Business logic to Proceed',
  },
  UNIQUE_VALUE_ERROR: {
    key: 'UNIQUE_VALUE_ERROR',
    value: 'Please enter a unique value',
  },
  SAVE_PREVIOUS_BL_ERROR: {
    key: 'SAVE_PREVIOUS_BL_ERROR',
    value: `To proceed with creating new business logic, first save the one you're actively working on.`,
  },
  SAVE_BL_ERROR: {
    key: 'SAVE_BL_ERROR',
    value: `There was an issue with saving the business logic. Please try again.`,
  },
  DELETE_BL_ERROR: {
    key: 'DELETE_BL_ERROR',
    value: `There was an issue with deleting the business logic. Please try again.`,
  },
  DELETE_BL_CONFIRM: {
    key: 'DELETE_BL_CONFIRM',
    value: `Sure to delete?`,
  },
  DELETE_CONDITION: {
    key: 'DELETE_CONDITION',
    value: `Delete Condition`,
  },
  BL_CONFIRM_YES: {
    key: 'BL_CONFIRM_YES',
    value: `Yes`,
  },
  BL_CONFIRM_NO: {
    key: 'BL_CONFIRM_NO',
    value: `No`,
  },
  ADD_MORE: {
    key: 'ADD_MORE',
    value: `Add more`,
  },
  NEXT_TEXT: {
    key: 'NEXT_TEXT',
    value: `Next`,
  },
  VALUE_LABEL: {
    key: 'VALUE_LABEL',
    value: 'Value',
  },
  OPERATOR_PLACEHOLDER: {
    key: 'OPERATOR_PLACEHOLDER',
    value: 'Operator',
  },
  MATCH_ALL: {
    key: 'MATCH_ALL',
    value: 'match all',
  },
  MATCH_FIRST: {
    key: 'MATCH_FIRST',
    value: 'match first',
  },
  MATCH_LAST: {
    key: 'MATCH_LAST',
    value: 'match last',
  },
  CANCEL_BUTTON: {
    key: 'CANCEL_BUTTON',
    value: 'Cancel',
  },
  EMPTY_RULE_ERROR_MESSAGE: {
    key: 'EMPTY_RULE_ERROR_MESSAGE',
    value: 'Select a section name for rule {{value}}',
  },
  EMPTY_CONDITION_ERROR_MESSAGE: {
    key: 'EMPTY_CONDITION_ERROR_MESSAGE',
    value: 'Select a variable for condition {{value}}',
  },
  ADD_BUSINESS_LOGIC_LABEL: {
    key: 'ADD_BUSINESS_LOGIC_LABEL',
    value: 'Add business logic',
  },
  EDIT_BUSINESS_LOGIC_LABEL: {
    key: 'EDIT_BUSINESS_LOGIC_LABEL',
    value: 'Edit business logic',
  },
  ADD_BUSINESS_LOGIC_CAPS_LABEL: {
    key: 'ADD_BUSINESS_LOGIC_CAPS_LABEL',
    value: 'Add Business Logic',
  },
  EDIT_BUSINESS_LOGIC_CAPS_LABEL: {
    key: 'EDIT_BUSINESS_LOGIC_CAPS_LABEL',
    value: 'Edit Business Logic',
  },
  BUSINESS_LOGIC_NAME: {
    key: 'BUSINESS_LOGIC_NAME',
    value: 'Business Logic Name',
  },
  SECTION_NAME: {
    key: 'SECTION_NAME',
    value: 'Section Name',
  },
  BUSINESS_LOGIC_NAME_PLACEHOLDER: {
    key: 'BUSINESS_LOGIC_NAME_PLACEHOLDER',
    value: 'Pick an existing logic or give a name to start a new one',
  },
  SECTION_NAME_PLACEHOLDER: {
    key: 'SECTION_NAME_PLACEHOLDER',
    value: 'Name this Logic',
  },
   SECTION_NAME_PLACEHOLDER1: {
    key: 'SECTION_NAME_PLACEHOLDER1',
    value: 'Name this section',
  },
  SECTIONS_ADDED: {
    key: 'SECTIONS_ADDED',
    value: 'Sections added to this logic ',
  },
  NAVIGATE_TO_PAGE: {
    key: 'NAVIGATE_TO_PAGE',
    value: 'Navigate to the page',
  },
 BL_LOGIC_SUCCESS: {
    key: 'BL_LOGIC_SUCCESS',
    value: 'Business logic saved successfully',
  },
};

export const PAGE_NUMBER_TRANS = {
  PAGE_CONTENT: {
    key: 'PAGE_CONTENT',
    value: 'Page',
  },
  LEFT_LABEL: {
    key: 'LEFT_LABEL',
    value: 'Left',
  },
  TOP_LABEL: {
    key: 'TOP_LABEL',
    value: 'Top',
  },
  TEXT_LABEL: {
    key: 'TEXT_LABEL',
    value: 'Text',
  },
  COLOR_LABEL: {
    key: 'COLOR_LABEL',
    value: 'Color',
  },
  DRAG_DROP_INFO: {
    key: 'DRAG_DROP_INFO',
    value: 'Drag and Drop to the Header or Footer Section.',
  },
};

export const COMPLEX_DOCUMENT_ENVIRONMENT = {
  DEFAULT_ERROR_MESSAGE: {
    key: 'DEFAULT_ERROR_MESSAGE',
    value: 'Sorry, we are unable to process this operation. Please try again after some time'
  },
  MOVED_TO_TESTING_SUCCESSFULLY_MESSAGE: {
    key: 'MOVED_TO_TESTING_SUCCESSFULLY_MESSAGE',
    value: 'Design moved to testing successfully.'
  }
}

export const IMAGE_TOOLBAR = {
  CHANGE_TO_DYNAMIC_IMAGE: {
    key: 'CHANGE_TO_DYNAMIC_IMAGE',
    value: 'Provide image link dynamically'
  },
  CHANGE_TO_DYNAMIC_IMAGE_LABEL: {
    key: 'CHANGE_TO_DYNAMIC_IMAGE_LABEL',
    value: 'Change to Dynamic image'
  }
}

export const ACCESSIBILITY_VALIDATOR_TRANSLATION = {
  ENABLE_ACCESSIBLE_DESIGN: {
    key:'ENABLE_ACCESSIBLE_DESIGN',
    value: 'Enable Accessible Design'
  },
    ENABLE_ACCESSIBLE_DESIGN_MESSAGE: {
    key:'ENABLE_ACCESSIBLE_DESIGN_MESSAGE',
    value: 'Modify your design to be more readable to people with disabilities, including those using screen readers and other assistive technologies'
  },
  ALT_TEXT_MESSAGE: {
    key: 'ALT_TEXT_MESSAGE',
    value:'Please provide an alternative text to this image'
  },
  COLOR_CONTRAST_MESSAGE: {
    key:'COLOR_CONTRAST_MESSAGE',
    value: 'Text is not readable due to low contrast in choice of colors'
  },
  SUMMARY_MESSAGE: {
    key:'SUMMARY_MESSAGE',
    value: 'Consider enhancing accessibility for screen reader users by including a short, clear summary in the document settings'
  },
  ACCESSIBILITY_VALIDATION_SUCCESS_HEADING:{
    key:'ACCESSIBILITY_VALIDATION_SUCCESS_HEADING',
    value: 'Accessibility Validation Complete'
  },
  ACCESSIBILITY_VALIDATION_SUCCESS_MESSAGE:{
    key:'ACCESSIBILITY_VALIDATION_SUCCESS_MESSAGE',
    value: 'All elements are readable and a summary is provided. The document meets core accessibility requirements'
  },
  ELEMENT_TABNAME:{
    key: 'ELEMENT_TABNAME',
    value: 'Unreadable elements'
  },
  SUGGESTIONS_TABNAME:{
    key: 'SUGGESTIONS_TABNAME',
    value: 'Suggestions'
  },
  PAGE:{
    key: 'PAGE',
    value: 'Page'
  },
  ENABLE_ACCESSIBILITY_TEXT: {
    key: 'ENABLE_ACCESSIBILITY_TEXT',
    value: 'Enable Accessibility in Document Settings to access this section'
  }
}

export const ACCESSIBILITY_TOOL_TIPS = {
  PARAGRAPH : {
    key: 'PARAGRAPH',
    value: 'Paragraph'
  },
  HEADING_ONE : {
    key: 'HEADING_ONE',
    value: 'Heading 1',
  },
  HEADING_TWO : {
    key: 'HEADING_TWO',
    value: 'Heading 2',
  },
  HEADING_THREE : {
    key: 'HEADING_THREE',
    value: 'Heading 3',
  },
  HTML_INFO : {
    key: 'HTML_INFO',
    value: 'Dynamic values will be treated as paragraph content.',
  },
  LINK : {
    key: 'LINK',
    value: 'Link',
  },
  LIST : {
    key: 'LIST',
    value: 'List',
  },
  ALTERNATE_TEXT : {
    key: 'ALTERNATE_TEXT',
    value: 'Alternate text for {{val}}',
  },
  STATIC_TABLE_INFO: {
    key: 'STATIC_TABLE_INFO',
    value: 'Row {{row}}, Column {{col}} will be treated as paragraph content.'
  },
  LIST_ALT_TEXT:{
    key:'LIST_ALT_TEXT',
    value:'Alternative Text'
  },
  LIST_COLOR_CONTRAST:{
    key:'LIST_COLOR_CONTRAT',
    value:'Color contrast'
  },
  LIST_DOC_SUMMARY:{
    key:'LIST_DOC_SUMMARY',
    value:'Document summary'
  },
  LIST_SECTION_SUMMARY:{
    key:'LIST_SECTION_SUMMARY',
    value:'Section summary'
  },
  TO_FIX:{
    key:'TO_FIX',
    value:'Issues',
  },
  BACK_TO_ACCESSIBILITY:{
    key:'BACK_TO_ACCESSIBILITY',
    value:'Back to Accessibility Settings',
  },
  FINDINGS:{
    key:'FINDINGS',
    value:'Findings: '
  },
  NAVIGATE_TO_IMAGE:{
    key:'NAVIGATE_TO_IMAGE',
    value:'Navigate to the image section'
  },
  ALT_TEXT_BUTTON:{
    key:'ALT_TEXT_BUTTON',
    value: 'Provide Alt Text'
  },
  TAP_TO_SECTION:{
    key:'TAP_TO_SECTION',
    value:'Tap to improve this section'
  },
  COLOR_CONTRAST_INFO:{
    key:'COLOR_CONTRAST_INFO',
    value:'Enhance clarity with better contrast'
  },
  DESCRIPTIVE_DOCUMENT_SUMMARY:{
    key:'DESCRIPTIVE_DOCUMENT_SUMMARY',
    value:'Include descriptive document summary'
  },
  DESCRIPTIVE_EMAIL_SUMMARY:{
    key:'DESCRIPTIVE_EMAIL_SUMMARY',
    value:'Include descriptive email summary'
  },
  NAVIGATE_TO_SECTION:{
    key:'NAVIGATE_TO_SECTION',
    value:'Navigate to this section'
  },
  PROVIDE_SUMMARY:{
    key:'PROVIDE_SUMMARY',
    value:'Provide Summary'
  },
  RESOLVED_CARD_HEADING:{
    key:'RESOLVED_CARD_HEADING',
    value:'Great Job!'
  },
  RESOLVED_CARD_INFO:{
    key: 'RESOLVED_CARD_INFO',
    value: 'You’ve successfully completed this section.'
  },
   RESOLVED_CARD_INFO_MESSAGE:{
    key: 'RESOLVED_CARD_INFO_MESSAGE',
    value: ' Your document is now one step closer to being fully accessible.Let’s move on to the next section to finish making it fully accessible'
  },
  NO_ACCESSIBLE_CONTENT:{
    key:'NO_ACCESSIBLE_CONTENT',
    value:`This document doesn't have any accessible contents yet.`
  },
  EMAIL_RESOLVED_CARD_INFO_MESSAGE:{
    key: 'EMAIL_RESOLVED_CARD_INFO_MESSAGE',
    value: ' Your email is now one step closer to being fully accessible.Let’s move on to the next section to finish making it fully accessible'
  },
}

export const COMPLETE_TRANSACTION = {
  MODAL_TITLE:{
    key: 'MODAL_TITLE',
    value: 'TRANSANCTION COMPLETE'
  },
  CONFIRM_BUTTON: {
    key: 'CONFIRM_BUTTON',
    value: 'CONFIRM'
  },
  CONFIRM_MODAL_DESCRIPTION: {
    key: 'CONFIRM_MODAL_DESCRIPTION',
    value: 'Are you sure you want to finalize the changes to the document and complete it?'
  },

}

export const LOGIC_LIST_VALUE = {
  CURRENT_DATE: {
    key: 'CURRENT_DATE',
    value: 'Date of generating the document'
  },
  CURRENT_TIME: {
    key: 'CURRENT_TIME',
    value: 'Time of generating the document'
  },
  CURRENT_DATE_TIME: {
    key: 'CURRENT_DATE_TIME',
    value: 'Date and time of generating the document'
  },
  CURRENT_USER: {
    key: 'CURRENT_USER',
    value: 'current user name'
  },
  CUSTOM_LOGIC: {
    key: 'CUSTOM_LOGIC',
    value: 'write your own logic'
  },
}

export const LOGIC_LIST_DESC = {
  CURRENT_DATE: {
    key: 'CURRENT_DATE',
    value: 'Date of generating the document'
  },
  CURRENT_TIME: {
    key: 'CURRENT_TIME',
    value: 'Time of generating the document'
  },
  CURRENT_DATE_TIME: {
    key: 'CURRENT_DATE_TIME',
    value: 'Date and time of generating the document'
  },
  CURRENT_USER: {
    key: 'CURRENT_USER',
    value: 'current user name'
  },
  CUSTOM_LOGIC: {
    key: 'CUSTOM_LOGIC',
    value: 'write your own logic'
  },
}

export const VERSION_APPROVAL_PROCESS = {
  SEND_FOR_TESTING: {
    key: 'SEND_FOR_TESTING',
    value: 'Send For Testing'
  },
  REQUEST_FOR_APPROVAL: {
    key: 'REQUEST_FOR_APPROVAL',
    value: 'Request For Approval'
  },
  WAITING_FOR_APPROVAL: {
    key: 'WAITING_FOR_APPROVAL',
    value: 'Waiting For Approval'
  },
  PUBLISH: {
    key: 'PUBLISH',
    value: 'Publish'
  },
  REJECT: {
    key: 'REJECT',
    value: 'Reject'
  },
  CREATE_TAG_HEADER: {
    key: 'CREATE_TAG_HEADER',
    value: 'Provide a name to create a tag on the current testing version',
  },
  CREATE_TAG_HEADER_FOR_PUBLISH: {
    key: 'CREATE_TAG_HEADER_FOR_PUBLISH',
    value: 'Provide a name to create a tag on the current publishing version',
  },
  CREATE_TAG: {
    key: 'CREATE_TAG',
    value: 'Create Tag'
  },
  SKIP_AND_PROCEED: {
    key: 'SKIP_AND_PROCEED',
    value: 'Skip & Proceed'
  },
  REJECTED: {
    key: 'REJECTED',
    value: 'Rejected'
  },
  TAG_CREATION_FAILURE: {
    key: 'TAG_CREATION_FAILURE',
    value: 'Tag creation failed. Please retry again later'
  },
  REJECTION_SUCCESS: {
    key: 'REJECTION_SUCCESS',
    value: 'Request rejected successfully'
  },
  REJECTION_FAILURE: {
    key: 'REJECTION_FAILURE',
    value: 'Couldn’t reject the request. Please try again.'
  },
  REJECTION_COMMENT: {
    key: 'REJECTION_COMMENT',
    value: 'Provide Your Comments'
  },
  CONFIRM_BUTTON: {
    key: 'CONFIRM_BUTTON',
    value: 'Confirm'
  },
  PLACEHOLDER_TAG_NAME: {
    key: 'PLACEHOLDER_TAG_NAME',
    value: 'Enter tag name'
  },
  TAG_NAME_LABEL: {
    key: 'TAG_NAME_LABEL',
    value: 'Tag Name'
  },
  TAG_NAME_EMPTY_ERROR: {
    key: 'TAG_NAME_EMPTY_ERROR',
    value: 'Please enter tag name.'
  },
  TAG_EXISTS_ERROR: {
    key: 'TAG_EXISTS_ERROR',
    value: 'Tag creation failed. The tag name must be unique.'
  },
  REJECTION_COMMENT_MANDATORY:{
    key:'REJECTION_COMMENT_MANDATORY',
    value:'Please provide a comment before rejecting the template.'
  },
}

export const DKV_CREATE_NEW_BLOCK = {
  SECTION_NAME_UNSUPPORTED_CHARS: {
    key: 'SECTION_NAME_UNSUPPORTED_CHARS',
    value: 'The name contains unsupported characters: "{{char}}". Please use only letters, numbers, or these special characters: - _ ( ).'
  },
}

